import type { PublicClient } from "viem"

import type { IPublicClientGetter } from "@/domains/library"

/**
 * Adapter that wraps a function returning PublicClient to implement IPublicClientGetter.
 * This allows components to always get the latest PublicClient instance.
 */
export class PublicClientGetterAdapter implements IPublicClientGetter {
  constructor(private readonly getPublicClient: () => PublicClient) {}

  get(): PublicClient {
    return this.getPublicClient()
  }
}
